import { ChevronRight } from '@mui/icons-material';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function InPersonEventItem({ inPersonEvent }) {
	const navigate = useNavigate();

	const handleClick = () => navigate(`/in-person-events/${inPersonEvent.id}`);

	return (
		<Grid item xs={5} sm={6} md={4} onClick={() => handleClick()}>
			<Paper
				elevation={1}
				style={{
					border: '1px solid #6BE0A0',
					borderRadius: 8,
					padding: 16,
					width: '100%',
					cursor: 'pointer',
					gap: 10
				}}
			>
				<Box display={'flex'} justifyContent={'space-between'} mb={2}>
					<Typography variant="h5">{inPersonEvent.name}</Typography>
					<ChevronRight fontSize={'large'} />
				</Box>
				<Grid container mb={2}>
					<Grid item xs={6}>
						<Typography variant="body1" color="textSecondary">
							{'End Date'}
						</Typography>
						<Typography variant="h6" color="textSecondary">
							{new Date(inPersonEvent?.end_date)?.toLocaleDateString('en-GB')}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography variant="body1" color="textSecondary">
							{'Number of participants'}
						</Typography>
						<Typography variant="h6" color="textSecondary">
							{inPersonEvent.event_participants_count}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
		</Grid>
	);
}
